<template>
    <div>
        <div id="indextop" class="h66">
            <div class="pa20 l">
                <div id="logo" width="98" height="40"></div>
            </div>
        </div>
        <div id="lapi" class="cfff" style="text-align: center;font-size: 26px;">
            欢迎回来！通信录/CRM/人脉和38万用户一起，方便、省钱40%！
        </div>
        <div id="register_a">
            <div class="w750">
                <h1 class="mt20 f20 cff2104 tal">用户找回登录密码</h1>
                <ul class="mt20 f14">
                <li  class="mb30 yz ">
                    <div class="l w100 h36 tar">选择验证方式：</div>
                    <div class="vocation">
                        <el-select v-model="type" placeholder="短信验证码" :disabled="selectShow">
                            <el-option
                                v-for="item in typeOptions"
                                :key="item.value"
                                :label="item.text"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                </li>
                <li  class="mb30 yz">
                    <div class="l w100 h36 tar">手机号码：</div>
                    <div class="l h36">
                        <el-input placeholder="请输入绑定的手机号码" v-on:input="inputMobile" v-model="mobile" style="width:175px;" :disabled="inputDis" maxlength="11"></el-input>                        
                    </div>
                </li> 
                <li  class="mb30 yz">
                    <div class="l w100 h36 tar">图形验证码：</div>
                    <div class="l h36">
                        <el-input placeholder="请输入图形验证码" v-on:input="inputCode" v-model="loginCode" style="width:190px;" maxlength="4"></el-input>                        
                        
                    </div>
                    <div class="code" @click="refreshCode">
                        <s-identify :identifyCode="identifyCode"></s-identify>
                    </div>
                </li> 
                <!-- <li  class="mb30 yz" v-show="countShow">
                    <div class="l w100 h36 tar">验证手机号码：</div>
                    <div class="l h36"><span class="cf06000" style="font-size: 14px;">{{mobile}}</span></div>
                    {{mobile.slice(0,3)}}****{{mobile.slice(7,11)}}
                    <div class="l f14 ml10 h36"><el-tag type="warning" style="letter-spacing: 1px;">验证码已发送请注意查收</el-tag></div>
                </li> -->

                <li  class="mb30 yz">
                    <div class="l w100 h36 tar">短信验证码：</div>
                    <div class="l h36">
                        <el-input placeholder="请输入手机收到的验证码" v-on:input="inputSmsCode" v-model="code" style="width:190px;" :disabled="inputSmsCodeDisable"></el-input>
                        <el-button type="primary" v-show="sendcodeShow" class="top_button" @click="sendcode()" style="margin-left: 15px;letter-spacing: 2px;">获取验证码</el-button>
                        <el-button type="primary" v-show="sendcodeagainShow" class="top_button" @click="sendcode()" style="margin-left: 15px;letter-spacing: 2px;" >重新获取验证码</el-button>                        
                        <el-button type="primary" v-show="countShow" class="top_button" style="margin-left: 15px;letter-spacing: 2px;"><label style="color: red;">{{count}} </label>秒后重新发送</el-button>
                        <el-tag type="warning" style="letter-spacing: 1px;margin-left:10px;" v-show="countShow">短信验证码已发送请,注意查收</el-tag>
                    </div>
                </li>
                <li  class="mb30 yz">
                <div class="l w100 h36 tar"> &nbsp; </div>
                <div class="l ">
                    <el-button type="primary" class="top_button" @click="checkcode()" style="letter-spacing: 2px;" v-show="btnSubmitShow" >提交</el-button>
                    <el-button type="primary" class="top_button" @click="goindex()" style="margin-left:15px;letter-spacing: 2px;">返回首页</el-button>
                </div>
                </li>
                </ul>
            </div>
        </div>

        <div class="w990 tal f14" style="margin-bottom: 20px; overflow: hidden;">
            <dd class="h36">
                咨询电话：免长途 <label class="cf06000">40060 88590 / 0571-88932028</label>
            </dd>
            <dd class="h36">
                联系客服：
                旺旺&nbsp;&nbsp;<img src="@/images/ww.gif" width="77" height="19" style="cursor: pointer;" @click="talkww()">
                &nbsp;&nbsp;QQ：&nbsp;&nbsp;<a href="tencent://message/?uin=2040399162&Site=http://vps.shuidazhe.com&Menu=yes" target="_blank">2040399162</a>
                <!-- <a target="_blank" href="//wpa.b.qq.com/cgi/wpa.php?ln=1&key=XzgwMDAyMDIxNF80ODkyNjJfODAwMDIwMjE0XzJf"><img border="0" src="//wpa.qq.com/pa?p=2:800020214:41" alt="点击咨询" title="点击咨询"/></a> -->
                <!-- <img src="@/images/qq.gif" width="71" height="24" style="cursor: pointer;" @click="talkqq()"> -->
            </dd>
        </div>

        <div class="w990 tal f14">
        <span><img src="@/images/dp.png" alt="提醒" /><b>注意</b></span>
        </div>
            <ul class="w990 tal f14 h36">
                <li>1.提供电子邮箱、手机号码将提高您的账号等级。未验证用户将无法使用，可能被销户</li>
                <li>2.每天获取密码次数受限；找密码短信费用：0.1元/条;语音:0.18元/分钟</li> 
                <li>3.如果账户无余额，可以免费获取密码短信3次;</li>
                <li>4.如手机号码变更请及时验证调整，以免影响使用或被人盗用余额</li>
                <li>5.(重要：API接口用户 修改密码前必须要联络第二办公室技术进行同步，否则影响API使用; 如被强制修改后，您可马上再改回原密码, 就不影响使用)</li>
            </ul>
        </div>
    </div>
</template>

<script>
import {isMobil, is_number} from '@/assets/js/checkFunction.js'

export default {
    data() {
        return {
            mobile: '',
            code: '',
            type: 'pwdsms',
            typeOptions: [
                { text: '短信获取密码', value: 'pwdsms'},
                { text: '语音获取密码', value: 'pwdphone'},
            ],
            count: 60,
            isShow: true,
            timer: false,
            sendcodeShow: false,
            countShow: false,
            inputDis: false,
            sendcodeagainShow: false,
            selectShow: false,
            identifyCodes: "1234567890",
            identifyCode: "",
            loginCode: '',
            btnSubmitShow:false,
            inputSmsCodeDisable:true,
        }
    },
    mounted() {        
        this.makeCode(this.identifyCodes, 4);
    },
    methods: {
        //找回密码，下发短信验证码
        sendcode() {
            if(!isMobil(this.mobile))
            {
                this.$message.error("请输入正确的手机号");
                return false;
            }
            if(this.loginCode != this.identifyCode){
                alert("图形验证码不正确")
                return
            }
            let param = {'mobile': this.mobile, 'type': this.type};
            var that = this;
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + "/getpassword/findpasswordsendcode.json",
                data: param,
                headers: {
                    'Content-Type': 'application/json;charset=UTF-8',
                    'token': this.GLOBAL.token,
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    that.timeSetInterval();
                    that.inputDis = true;
                    that.sendcodeShow = false;
                    that.sendcodeagainShow = false;
                    that.countShow = true;
                    that.selectShow = true;
                    that.inputSmsCodeDisable = false;
                }
                else
                {
                    that.$alert(res.data.msg);
                    that.refreshCode();
                    return false;
                }
            })
        },
        timeSetInterval() {
            //60秒倒计时
            let that = this;
            if(!this.timer)
            {
                
                //这里用 ()=>箭头函数可以不用that  因为箭头函数的对象为全局对象 function() 的对象为局部对象
                this.timer = setInterval(function() {
                    if(that.count > 0 && that.count <= 60)
                    {
                        that.count--;
                    }
                    else
                    {
                        clearInterval(that.timer);
                        that.timer = false;
                        that.count = 60;
                        that.sendcodeagainShow = true;
                        that.countShow = false;
                        
                    }
                }, 1000);
            }
        },
        //验证下发验证码是否填写正确，并修改密码下发给用户
        checkcode() {
            var that = this;
            
            let param = {'mobile': this.mobile, 'type': this.type, 'code': this.code}
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + '/getpassword/findpasswordcheckcode.json',
                data: param,
                headers: {
                    'Content-Type': 'application/json;charset=UTF-8',
                    'token': this.GLOBAL.token,
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    that.$alert(res.data.msg, '提示', {
                        confirmButtonText: '确定', 
                    }).then( () => {
                        that.$router.push("/");
                    });
                }
                else
                {
                    that.$alert(res.data.msg);
                    
                    return false;
                }
            })
        },
        goindex() {
            this.$router.push("/");
        },
        talkww() {
            window.open("//amos1.taobao.com/msg.ww?v=2&uid=2office&s=1");
        },
        talkqq() {
            // window.open("//wpa.qq.com/msgrd?v=3&uin=800020214&site=qq&menu=yes");
            window.open("//wpa.qq.com/msgrd?v=3&uin=2040399162&site=hupaiyule&menu=yes");
        },
        makeCode(o, l) {
            for (let i = 0; i < l; i++) {
                this.identifyCode += this.identifyCodes[
                    this.randomNum(0, this.identifyCodes.length)
                ];
            }
        },
        randomNum(min, max) {
            return Math.floor(Math.random() * (max - min) + min);
        },
        refreshCode() {
            this.identifyCode = "";
            this.makeCode(this.identifyCodes, 4);
        },
        inputMobile(){
            if(this.mobile.trim().length == 11 && this.loginCode.trim().length == 4 && this.loginCode == this.identifyCode)
            {
                this.sendcodeShow = true;
            }
        },
        inputCode(){
            if(this.mobile.trim().length == 11 && this.loginCode.trim().length == 4 && this.loginCode == this.identifyCode)
            {
                this.sendcodeShow = true;
            }
        },
        inputSmsCode(){
            if(this.code.trim().length == 4){
                this.btnSubmitShow = true;
            }
        }
    }
}

</script>


// WEBPACK FOOTER //
// src/components/getpassword.vue